import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../../services/oms-service.service';
import { ConstantsService } from '../../services/constants.service';
import { SharedService } from '../../../../../tools/src/lib/shared/shared.service';
import { combineLatest } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-samples-submited',
  templateUrl: './samples-submited.component.html',
  styleUrls: ['./samples-submited.component.scss']
})
export class SamplesSubmitedComponent implements OnInit {

  @Input() isSendStatus;
  @Input() order_id;

  pickupboyRadioOptions=new FormControl('')
  pickup_boy_name = new FormControl('');
  pickup_boy_mobile = new FormControl('');
  pickup_boyOTP = new FormControl('');
  
  isOtpSend = false;
  isSampleProcessing: Number = 0;

  constructor(
    public modal: NgbActiveModal,
    private omsServiceService: OmsServiceService,
    private constantsService: ConstantsService,
    private sharedService: SharedService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    console.log(`order_id`,this.order_id)
  }

  modelClose()
  {
    this.modal.close();
  }

 sampleSubmission(){
    // alert(this.pickupboyRadioOptions.value)
      if (this.pickupboyRadioOptions.value != "" && this.pickupboyRadioOptions.value != null && this.pickupboyRadioOptions.value != undefined) {
        if (this.pickup_boy_name.value != "" && this.pickup_boy_name.value != null && this.pickup_boy_name.value != undefined) {
          if (this.pickup_boy_mobile.value != "" && this.pickup_boy_mobile.value != null && this.pickup_boy_mobile.value != undefined) {
            let sampleSubmissionRequest = {};
            sampleSubmissionRequest["order_id"] = this.order_id;
            sampleSubmissionRequest["option"] = 1;
            sampleSubmissionRequest["status"] = 103;
            sampleSubmissionRequest["source"] = 'Doctor';
            sampleSubmissionRequest["actionById"] = window.localStorage.getItem('actionById');
            sampleSubmissionRequest["actionByName"] = window.localStorage.getItem('actionByName');
            sampleSubmissionRequest["latitude"] = '21.34539';
            sampleSubmissionRequest["longitude"] = '78.456456';
            sampleSubmissionRequest["pickUpBoyName"] = this.pickup_boy_name.value;
            sampleSubmissionRequest["pickUpBoyNo"] = this.pickup_boy_mobile.value;
            sampleSubmissionRequest["pickUpBoyType"] = this.pickupboyRadioOptions.value;
            sampleSubmissionRequest["isInternalCall"] = 1;
            sampleSubmissionRequest["type"] = "post";
            sampleSubmissionRequest["action"] = "OMS/api/operation.php/v1/order/change/status";

                  console.log(`sampleSubmissionRequest`,sampleSubmissionRequest)
                  this.omsServiceService.orderConfirmation(sampleSubmissionRequest).subscribe(
                  (res:any) => {
                      console.log(`sampleSubmissionResponse`,res)
                      if (res.status == 1) {
                        this.toastr.success(res.message);
                          setTimeout(function(){                          
                            window.location.reload();
                          }, 2000);
                      }else{
                        this.toastr.error(res.message);
                      }
                  })
          } else {
            this.toastr.error("please enter mobile no");
          }
        } else {
          this.toastr.error("please enter pickup boy name");
        }
    } else {
      this.toastr.error("please select pickup boy from");
    }
  }

   sendOTPforsamplesubmission(type){

          let otpRequest = {};
          otpRequest["type"] = "post";
          otpRequest["mobile"] = this.pickup_boy_mobile.value;
          otpRequest["email"] = "donotreply@callhealth.com";
          otpRequest["keyValue"] = "MHO00213";
          otpRequest["keyType"] = "ISP";
          otpRequest["sourceType"] = "Mobile-APP";
     if(type == 'send_otp' || type == 'resend'){
          if (this.pickup_boy_mobile.value != "" && this.pickup_boy_mobile.value != null && this.pickup_boy_mobile.value != undefined) {
          otpRequest["method"] = "api/otp/generate";
            console.log(`otpRequest1`,otpRequest)
          } else {
            this.toastr.error("please enter mobile no");
          }
     }else if(type == 'verify_otp'){
          if (this.pickup_boyOTP.value != "" && this.pickup_boyOTP.value != null && this.pickup_boyOTP.value != undefined) {
                otpRequest["method"] = this.constantsService.OTP_VERIFY_METHOD;
                otpRequest["otp"] = this.pickup_boyOTP.value;
                console.log(`otpRequest`,otpRequest)
          }else{
            this.toastr.error("please enter valid otp");
          }
     }
            this.omsServiceService.sendOtp(otpRequest).subscribe(
              (res:any) => {
                 console.log(`otpResponse`,res.status )
                this.isOtpSend = true;
                if (res.status == 1) {
                  this.toastr.success(res.message);
                  if(type == 'verify_otp'){
                    this.sampleSubmission();
                  }
                }
              })
  }



}
